import React from "react";
import Canvas from "../../../components/Canvas";

const HeroSection = () => {
  return (
    <section className="page-hero">
      <Canvas />
      <div className="container page-hero-grid">
        <div>
          <p className="eyebrow">Effective Date: 06/25/2026</p>
          <h1>Protecting Your Data With Transparency and Trust</h1>
          <p className="hero-copy">
            We're committed to safeguarding your personal information through
            advanced security standards and ethical data practices.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
